import React, { forwardRef, useImperativeHandle, useContext, useRef } from "react";
import { Text } from "@fluentui/react";
import { SubledgerContext } from "../../contexts/SubledgerContext";
import MultiAutocomplete, { MultiAutocompleteRef } from "../../baseComponents/MultiAutocomplete";

interface ISLSearchFiscalYearAutocompleteProps {
  loading: boolean;
}

export interface ISLSearchFiscalYearAutocompleteRef {
  getFiscalYears: () => string[];
  setInitialFiscalYears: (initialFiscalYears: string[]) => void;
  reset: () => void;
}

const SLSearchFiscalYearAutocomplete = forwardRef((props: ISLSearchFiscalYearAutocompleteProps, ref) => {
  const { fiscalYears } = useContext(SubledgerContext);
  const autocompleteRef = useRef<MultiAutocompleteRef>(null);

  useImperativeHandle(
    ref,
    (): ISLSearchFiscalYearAutocompleteRef => ({
      getFiscalYears() {
        if (autocompleteRef.current) {
          return autocompleteRef.current.getSelectedItems();
        }
        return [];
      },
      setInitialFiscalYears(theInitialFiscalYears) {
        if (autocompleteRef.current) {
          autocompleteRef.current.setInitialSelectedItems(theInitialFiscalYears);
        }
      },
      reset() {
        if (autocompleteRef.current) {
          return autocompleteRef.current.reset();
        }
      }
    })
  );

  return (
    <React.Fragment>
      <MultiAutocomplete
        label="Fiscal Years"
        required={false}
        items={fiscalYears.value}
        ref={autocompleteRef}
        disabled={props.loading}
      />
      <Text
        nowrap
        variant="xSmall"
        block
        style={{
          marginTop: "4px",
          color: "var(--accent-font-color, #727272)"
        }}
      >
        Multiple fiscal years enabled. Separate by semicolons.
      </Text>
    </React.Fragment>
  );
});

SLSearchFiscalYearAutocomplete.displayName = "SLSearchFiscalYearAutocomplete";

export default SLSearchFiscalYearAutocomplete;
